var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-flex align-items-center position-relative",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openCart}},[_c('span',{staticClass:"carrello-nr",domProps:{"textContent":_vm._s(_vm.counter)}}),_vm._v(" "),_c('img',{staticClass:"m-0",attrs:{"height":"29","src":'/images/area-utente/cart-' + _vm.theme + '.svg',"alt":"icona"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }